import { htmlSafe } from '@ember/template';
import Modal from 'tio-ui/components/modal';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import ErrorMessages from 'tio-ui/components/error-messages';

export interface TuitionAssistanceLimitsSummaryErrorAlertSignature {
  Args: {
    showError: boolean;
    errorMessage: string;
    explanation: string;
  };
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

export default class TuitionAssistanceLimitsSummaryErrorAlertComponent extends Component<TuitionAssistanceLimitsSummaryErrorAlertSignature> {
  @tracked isShowingDetailsDialog = false;

  toggleDetailsDialog = () => {
    this.isShowingDetailsDialog = !this.isShowingDetailsDialog;
  };

  <template>
    {{#if @showError}}
      <div class="tio-col-flush" ...attributes>
        <ErrorMessages @showErrors={{@showError}} @error={{@errorMessage}} />
        <button
          type="button"
          class="app-text-link app-text-link--inline"
          {{on "click" this.toggleDetailsDialog}}
        >
          {{t "tuition_assistance.limits_summary.explain_limit"}}
        </button>
      </div>
      <Modal
        @isOpen={{this.isShowingDetailsDialog}}
        @onClose={{this.toggleDetailsDialog}}
        @ariaLabel={{t "common.aria_labels.limit_explanation"}}
      >
        <:body>
          <div class="app-rich-text">{{htmlSafe @explanation}}</div>
        </:body>
      </Modal>
    {{/if}}
  </template>
}
